import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getWSService } from 'js/WebSocketService';
import * as batchesActions from '../redux/actions/batches';
import * as closedBatchesActions from '../redux/actions/closedBatches';
import * as vehicleActions from '../redux/actions/auctions';

const useSocketListeners = () => {
    const dispatch = useDispatch();

    const pujasMessageHandler = useCallback(
        (evt, counter) => {
            const { Vehicles, Batch } = evt.Data;
            const parsedVehicles = JSON.parse(Vehicles);

            if (Batch) {
                //update batch
                dispatch(closedBatchesActions.updateBatch(parsedVehicles));
            } else {
                dispatch(batchesActions.disableCarsFromBatch(parsedVehicles));

                dispatch(
                    vehicleActions.updateVehiclesList({
                        WebSalesId: +parsedVehicles[0],
                        updatedAWSAmounts: false,
                    })
                );
            }
        },
        [dispatch]
    );

    const directPurchaseMessageHandler = useCallback(
        (evt, counter) => {
            const { Vehicles, Batch } = evt.Data;
            const parsedVehicles = JSON.parse(Vehicles);

            if (Batch) {
                //update batch
                dispatch(
                    closedBatchesActions.disableClosedBatch(parsedVehicles)
                );
            } else {
                dispatch(batchesActions.disableCarsFromBatch(parsedVehicles));

                dispatch(
                    vehicleActions.updateVehiclesList({
                        WebSalesId: +parsedVehicles[0],
                        Status: 3,
                    })
                );
            }
        },
        [dispatch]
    );

    const batchMessageHandler = useCallback(
        (evt, counter) => {
            const { Vehicles } = evt.Data; //IdPublish array of all vehicles that have been added to a batch
            if (Vehicles) {
                const parsedVehicles = JSON.parse(Vehicles);

                //disable from redux and auctions list
                dispatch(batchesActions.disableCarsFromBatch(parsedVehicles));

                dispatch(
                    vehicleActions.blockVehiclesFromList({
                        status: true,
                        vehicles: parsedVehicles,
                    })
                );
            }
        },
        [dispatch]
    );

    const deleteBatchMessageHandler = useCallback(
        (evt, counter) => {
            const { Vehicles } = evt.Data; //IdPublish array of all vehicles that have been removed from a batch
            if (Vehicles) {
                const parsedVehicles = JSON.parse(Vehicles);

                //enable from redux and auctions list
                dispatch(
                    batchesActions.enableCarsFromBatch({
                        cars: parsedVehicles,
                        counter,
                    })
                );

                dispatch(
                    vehicleActions.blockVehiclesFromList({
                        status: false,
                        vehicles: parsedVehicles,
                    })
                );
            }
        },
        [dispatch]
    );

    useEffect(() => {
        getWSService().addMessageListener(
            'pujas',
            'pujas',
            pujasMessageHandler
        );
        getWSService().addMessageListener(
            'directPurchase',
            'directPurchase',
            directPurchaseMessageHandler
        );
        getWSService().addMessageListener(
            'batches',
            'batches',
            batchMessageHandler
        );
        getWSService().addMessageListener(
            'deleteBatch',
            'deleteBatch',
            deleteBatchMessageHandler
        );
    }, [
        batchMessageHandler,
        deleteBatchMessageHandler,
        directPurchaseMessageHandler,
        pujasMessageHandler,
    ]);

    return;
};

export default useSocketListeners;
